import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import HeadlessInput from '../../../shared/component/headless/input/HeadlessInput';
import { MemberInfoValueMobile } from '../../../shared/component/headless/input/InputBody';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';
import { BlackFullWidthBtn } from '../../../shared/component/headless/button/BtnBody';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import { useValidation } from '../../../shared/hooks/useValidation';
import { useAuth } from '../../../shared/hooks/useApi/useAuth';
import { useStandardAlertStore } from '../../../shared/store/portal/alertStore';
import { useMember } from '../../../shared/hooks/useApi/useMember';
import { AlertPosition, AlertType } from '../../../shared/enum/EnumRepository';
import { getAlertMessage } from '../../../shared/constants/alertMessages';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import { getBtnName } from '../../../shared/constants/btnNames';
import Space from '../../../shared/Space';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import belowIcon from '../../../asset/icon/below.png';

interface ModalProps {
  setIsUserInput: (isUserInput: boolean) => void;
}

const ChangeHandleModalMobile: React.FC<ModalProps> = ({ setIsUserInput }) => {
  const { standardModal, clearModal } = useModalStore();
  const { user } = useAuth();
  const { isValidHandle, validateHandle } = useValidation();
  const { enqueueAlert } = useStandardAlertStore();
  const { updateHandle } = useMember();
  const [temp, setTemp] = useState(standardModal?.value || "");
  const [error, setError] = useState('');

  const handleValidate = (value: string) => {
    if (value.length === 0) {
      setError('');
      return true;
    }
    
    const errorMessage = validateHandle(value);
    if (errorMessage) {
      setError(errorMessage);
      return false;
    }
    
    setError('');
    return true;
  };

  useEffect(() => {
    if (temp.length > 0) {
      setIsUserInput(true);
    } else {
      setIsUserInput(false);
    }
  }, [temp]);

  if (user == null || standardModal == null) return null;

  const changeHandleInput = (value: string) => {
    const lowerValue = value.toLowerCase();
    setTemp(lowerValue);
    handleValidate(lowerValue);
  };

  const handleSubmit = async () => {
    // 빈 값 체크
    if (temp.length === 0) {
      setError('Please enter a URL name.');
      return;
    }
    if (temp === standardModal.value) {
      setError('Please enter a different URL name.');
      return;
    }
    // 형식 검증
    if (!handleValidate(temp)) {
      return;
    }
    if (!isValidHandle(temp)) {
      return;
    }

    enqueueAlert({
      type: AlertType.CONFIRM,
      position: AlertPosition.TOP,
      content: getAlertMessage('CONFIRM_CHANGE_LINK_ID'),
      callBack: () => {
        updateHandle({
          id: user.id,
          handle: temp,
        });
      }
    });
  };

  return (
    <ChangeModalComp>
      <TitleWrapper>
        <Title>{getModalMessage('CHANGE_LINK_ID_TITLE')}</Title>
        <UniversalIconBtn
          size="fit"
          border={false}
          isTransparent
          backgroundImg={belowIcon}
          onClick={() => clearModal(400)}
        />
      </TitleWrapper>
      <Example>
        www.architrave.work/@ 
        <HighlightText>{temp}</HighlightText>
      </Example>
      <HeadlessInput
        type={'text'}
        value={temp}
        handleChange={(e) => changeHandleInput(e.target.value)}
        placeholder={getModalMessage('ENTER_FIELD', { field: standardModal?.title ?? '' })}
        StyledInput={MemberInfoValueMobile}
      />
      <Space $height="12px">
        {error !== null && <ErrorText>{error}</ErrorText>}
      </Space>
      <HeadlessBtn
        value={getBtnName('CHANGE')}
        handleClick={handleSubmit}
        StyledBtn={SubmitButton}
      />
    </ChangeModalComp>
  );
};

const ChangeModalComp = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 12px;
`

const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  margin-top: clamp(12px, 2vh, 30px);
  margin-bottom: clamp(20px, 8vh, 30px);
`;

const Title = styled.h2`
  ${({ theme }) => theme.typography.Body_01_1};
  color: ${({ theme }) => theme.colors.color_Gray_02};
`;



const Example = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  font-style: oblique;
  text-align: left;
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_05};
`;

const HighlightText = styled.span`
  font-style: normal;
  padding-left: 2px;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
`;

const SubmitButton = styled(BlackFullWidthBtn)`
  margin: 20px 0px 15px 0px;
`;

const ErrorText = styled.p`
  width: 100%;
  color: ${({ theme }) => theme.colors.color_alert_red};
  ${({ theme }) => theme.typography.Body_04};
`;

export default ChangeHandleModalMobile;